import React from 'react';
import image1 from '../images/image1.jpg';
import image2 from '../images/image2.jpg';
import image3 from '../images/image3.jpg';
import image4 from '../images/image4.jpg';
import image5 from '../images/image5.jpg';
import image6 from '../images/image6.jpg';

const Gallery: React.FC = () => {
  const images = [
    { id: 1, src: image1, caption: 'Family vacation in Italy, Summer 1985' },
    { id: 2, src: image2, caption: 'Teaching John & Niamh to fish' },
    { id: 3, src: image3, caption: 'Car Trouble on the Beach' },
    { id: 4, src: image4, caption: 'Christmas party with family' },
    { id: 5, src: image5, caption: 'Sking with Mary' },
    { id: 6, src: image6, caption: 'John in the garden at home' }
  ];

  return (
    <div className="max-w-7xl mx-auto">
      {/* Section Title */}
      <div className="text-center mb-16">
        <h2 className="font-ornate text-4xl md:text-5xl text-burgundy-900 mb-4">Photo Gallery</h2>
        <div className="flex items-center justify-center gap-4">
          <div className="w-16 h-px bg-gold-400/30"></div>
          <div className="text-gold-400 text-xl">✤</div>
          <div className="w-16 h-px bg-gold-400/30"></div>
        </div>
      </div>

      {/* Main Content Container */}
      <div className="relative">
        {/* Decorative corners */}
        <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-gold-400/20"></div>
        <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-gold-400/20"></div>
        <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-gold-400/20"></div>
        <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-gold-400/20"></div>

        {/* Content with padding for corners */}
        <div className="px-8 py-12">
          {/* Introduction */}
          <div className="mb-12 text-center">
            <p className="font-serif text-xl text-burgundy-800 italic mb-6">
              A collection of cherished moments from a life well-lived, capturing the joy, love, and legacy of John David Smith.
            </p>
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {images.map((image) => (
              <div key={image.id} className="group relative">
                {/* Image Frame */}
                <div className="relative">
                  {/* Outer Frame */}
                  <div className="absolute -inset-3">
                    <div className="absolute inset-0 border-[3px] border-gold-400/20"></div>
                    <div className="absolute inset-[3px] border-[1px] border-gold-300/30"></div>
                  </div>
                  
                  {/* Image Container */}
                  <div className="relative overflow-hidden">
                    <img
                      src={image.src}
                      alt={image.caption}
                      className="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-105 group-hover:brightness-50"
                    />
                    
                    {/* Hover Overlay */}
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="text-center p-4">
                          <p className="font-serif italic text-white text-lg">{image.caption}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Decorative Footer */}
          <div className="mt-16 text-center">
            <div className="flex items-center justify-center gap-4">
              <div className="w-24 h-px bg-gold-400/30"></div>
              <div className="text-gold-400/80 text-xl">❧</div>
              <div className="w-24 h-px bg-gold-400/30"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery; 